import React from 'react';

import { Control, useWatch } from 'react-hook-form';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCardModal/ProgramActivityCardModal.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCardModal/components/CardHeader/CardHeader.mobile.module.scss';

interface ICardHeader {
    control: Control<IFields, IFields>;
}

export const CardHeaderMobile = ({ control }: ICardHeader) => {
    const fields = useWatch({
        control,
    });

    const { activityId, wbsValue, title } = fields;

    return (
        <div data-testid={'card-header-container'} className={classes.cardHeaderContainer}>
            {activityId && wbsValue && title && (
                <>
                    <div className={classes.row}>
                        <label htmlFor={'activityId'} className={classes.label}>
                            Activity ID:
                        </label>
                        <div>
                            <span id={'activityId'} className={classes.value}>
                                {activityId && activityId.label}
                            </span>
                        </div>
                    </div>
                    <div className={classes.row}>
                        <label htmlFor={'wbs'} className={classes.label}>
                            WBS:
                        </label>
                        <div>
                            <span id={'wbs'}>{wbsValue && wbsValue.label}</span>
                        </div>
                    </div>

                    <div className={classes.row}>
                        <span id={'title'} className={classes.header}>
                            {title && title}
                        </span>
                    </div>
                </>
            )}
        </div>
    );
};
